import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import { library as faLibrary } from '@fortawesome/fontawesome-svg-core'
import { faHome, faSearch, faPlus, faEdit, faTrash, faCheck, faCompressAlt, faExpandAlt, faEraser, faClock, faArrowAltCircleLeft, faUndo, faAlignLeft, faAlignCenter, faEye, faPaperclip, faClone, faServer, faBuilding, faHistory, faWindowClose, faCalendarDay, faLeaf, faTachometerAlt, faSun, faMoon, faGear, faUser, faPrint, faLock, faFile, faArrowUpFromBracket, faFilter, faPause, faPlay, faChevronDown, faChevronRight, faThLarge, faArrowUp, faArrowDown, faSnowflake, faTv, faJugDetergent, faFan, faKitchenSet, faFireBurner, faMugHot, faLightbulb, faComputer, faChargingStation, faPlug, faWind, faTemperatureHigh, faFire, faFireFlameSimple, faFaucet, faShower, faBath, faToilet, faSink, faSeedling, faWaterLadder, faTag, faDroplet } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { i18n } from './i18n'
import VueCtkDateTimePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import VueChartkick from 'vue-chartkick'
import Chart from 'chart.js/auto'
import 'chartjs-adapter-date-fns'
import { autoresize } from './directives/autoresize'
import { closeAllModals } from './utils/modals'
import 'bootstrap'

// CD typography: Poppins (self-hosted via @fontsource, CD manual section 04)
import '@fontsource/poppins/300.css'
import '@fontsource/poppins/400.css'
import '@fontsource/poppins/500.css'
import '@fontsource/poppins/600.css'
import '@fontsource/poppins/700.css'

// Bootstrap axios
axios.defaults.baseURL = '/api'
axios.defaults.headers.common.Accept = 'application/json'
axios.interceptors.response.use(
  response => response,
  (error) => {
    if (error.status === 401 && error.config && !error.config.__isRetryRequest) {
      // an expired session can hit while a dialog is open — clean up the
      // Bootstrap backdrop before it ends up covering the login page
      closeAllModals()
      store.dispatch('logout')
      router.push({ name: 'login' })
    }
    return Promise.reject(error)
  }
)

// Set up FontAwesome
faLibrary.add(faHome, faGear, faUser, faSearch, faPlus, faEdit, faTrash, faCheck, faCompressAlt, faExpandAlt, faEraser, faClock, faArrowAltCircleLeft, faUndo, faAlignLeft, faAlignCenter, faEye, faPaperclip, faClone, faServer, faBuilding, faHistory, faWindowClose, faCalendarDay, faLeaf, faTachometerAlt, faSun, faMoon, faPrint, faLock, faFile, faArrowUpFromBracket, faFilter, faPause, faPlay, faChevronDown, faChevronRight, faThLarge, faArrowUp, faArrowDown, faSnowflake, faTv, faJugDetergent, faFan, faKitchenSet, faFireBurner, faMugHot, faLightbulb, faComputer, faChargingStation, faPlug, faWind, faTemperatureHigh, faFire, faFireFlameSimple, faFaucet, faShower, faBath, faToilet, faSink, faSeedling, faWaterLadder, faTag, faDroplet)

const app = createApp(App)

app.use(router)
app.use(store)
app.use(i18n)

app.use(VueChartkick, { adapter: Chart })

app.component('font-awesome-icon', FontAwesomeIcon)
app.component('VueDatePicker', VueCtkDateTimePicker)

app.directive('autoresize', autoresize)

// v-title: sets native browser tooltip via title attribute
app.directive('title', {
  mounted (el, binding) { el.title = binding.value },
  updated (el, binding) { el.title = binding.value }
})

// Number formatting — available globally via app.config.globalProperties.$formatNumber
// Also exported from src/utils/format.js for direct import
app.config.globalProperties.$formatNumber = function (value, decimals = 2) {
  if (value == null || isNaN(value)) return '-'
  return Number(value).toLocaleString(navigator.language, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  })
}

app.mount('#app')
